import React from 'react';
// import { removeHtmlTags, checkBufferType, bufferToBase64 } from '../utilities/methods';

import "./Room.css";

// const SERVER = process.env.REACT_APP_API_URL;

const ImageViewer = ({ mediaFile }) => {
    // const typeFile = base64String ? checkBufferType(base64String) : "";

    const FilePreview = () => {
        if (mediaFile) {
            // const base64Image = bufferToBase64(base64String);

            if (mediaFile.endsWith(".png") || mediaFile.endsWith(".jpg") || mediaFile.endsWith(".jpeg") || mediaFile.endsWith(".gif")) {
                return (
                    <div className='col'>
                        <img src={mediaFile} style={{ width: '100%' }} />
                        {/* <img src={`data:image/png;base64,${base64Image}`} alt={`Image preview ${typeFile}`} style={{ width: '100%' }} /> */}
                    </div>
                );
            } else if (mediaFile.endsWith(".pdf")) {
                return (
                    <div className='col'>
                        <embed src={mediaFile} type="application/pdf" width="100%" height="600px" />
                        {/* <embed src={`data:application/pdf;base64,${base64Image}`} type="application/pdf" width="100%" height="600px" /> */}
                    </div>
                );
            } else if (mediaFile.endsWith(".mp4")) {
                return (
                    <div className='col'>
                        <video width="100%" height="600px" controls>
                            <source src={mediaFile} type="video/mp4"></source>
                            {/* <source src={`data:video/mp4;base64,${base64Image}`} type="video/mp4"></source> */}
                            Seu navegador não suporta vídeos embutidos.
                        </video>
                    </div>
                );
            }
        } else {
            return (<p>Formato de arquivo não suportado.</p>);
        }
    };

    return (
        FilePreview()
    );
};

export default ImageViewer;